import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Attachment20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <path
      d='M11.5304 3.53034C12.8944 2.16638 15.1058 2.16638 16.4698 3.53034C17.8337 4.8943 17.8337 7.10571 16.4698 8.46968L17.5304 9.53034C19.4802 7.58059 19.4802 4.41942 17.5304 2.46968C15.5807 0.519931 12.4195 0.519936 10.4698 2.46968L2.46976 10.4697C0.520013 12.4194 0.520006 15.5806 2.46975 17.5303C4.4195 19.4801 7.58067 19.4801 9.53041 17.5303L15.0304 12.0303C16.1025 10.9583 16.1025 9.04176 15.0304 7.96968C13.9583 6.8976 12.0418 6.8976 10.9698 7.96968L5.46976 13.4697L6.53042 14.5303L12.0304 9.03034C12.5246 8.53618 13.4756 8.53618 13.9698 9.03034C14.4639 9.5245 14.4639 10.4755 13.9698 10.9697L8.46976 16.4697C7.10579 17.8336 4.89437 17.8336 3.53041 16.4697C2.16646 15.1057 2.16646 12.8943 3.53042 11.5303L11.5304 3.53034Z'
      fill='currentColor'
    />
  </Svg>
);

Attachment20.displayName = 'Attachment20';
export default Attachment20;
